<template>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/211690909?title=0&byline=0&portrait=0&controls=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
</template>

<script>
    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/hessestudios/hessesettings'
    });
    export default {
        name: 'Video',
        data(){
            return {
                logo : ""
            };
        },
        mounted(){
            ax.get().then(response => {
                this.logo = response.data.hesse_field_logo;
            });
        }
    }
</script>
<style lang="scss">
    @import "../assets/styles/components/video.scss";
</style>

